import { BaseClient } from 'src/common-services/clients/base-client'

export class MockDataClient extends BaseClient {
  get(name: string): Promise<any> {
    return this.call(`/mock-data/${encodeURIComponent(name)}`, 'GET')
  }
}
